import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '@/common/constants/routes';
import { useGetFlexibleBenefitsSummary } from '@/common/integrations/menhir/employee/flexible-benefits/flexible-benefits.hooks';
import { BenefitPageHeader } from '@/web/components/BenefitPageHeader/BenefitPageHeader';
import { RoutedTabs } from '@/web/components/RoutedTabs/RoutedTabs';
import { ESWalletBenefitsLearningCentre } from '@/web/containers/Dashboard/ESWalletDashboard/containers/Benefits/components/ESWalletBenefitsLearningCentre/ESWalletBenefitsLearningCentre';
import { Flex, LazyValue, Text } from '@coverflex-tech/hypernova';
import { MoneyUtils } from '@coverflex-tech/hypernova-utils';
import { FlexibleBenefitsActivity } from '../ESWalletBenefitDetail/containers/ESWalletBenefitDetailDefault/components/FlexibleBenefitsActivity/FlexibleBenefitsActivity';

export const ESWalletBenefitsActivity = () => {
  const { t } = useTranslation();
  const [learningCentreOpen, setLearningCentreOpen] = useState(false);
  const { summary, isInitialLoading } = useGetFlexibleBenefitsSummary();
  return (
    <Flex flexDirection="column">
      <BenefitPageHeader
        topTitle={t('dashboard.benefits.title')}
        title={
          <Flex gap="md" alignItems="baseline">
            <LazyValue
              value={MoneyUtils.moneyToString(summary?.totalBalance)}
              isLoading={isInitialLoading}
            />
            <Text size="sm">{t('general.labels.from_your_gross_salary')}</Text>
          </Flex>
        }
        learnMoreI18nKey="dashboard.benefits.actions.learn_more"
        onInfoClick={() => setLearningCentreOpen(true)}
      />
      <RoutedTabs
        tabs={[
          {
            label: t('dashboard.benefits.tabs.benefits.title'),
            path: ROUTES.BENEFITS,
          },
          {
            label: t('navigation.activity'),
            path: ROUTES.BENEFITS_ACTIVITY,
          },
        ]}
      >
        <FlexibleBenefitsActivity />
      </RoutedTabs>
      {learningCentreOpen && (
        <ESWalletBenefitsLearningCentre
          onClose={() => setLearningCentreOpen(false)}
          availableMethods={['app', 'card']}
        />
      )}
    </Flex>
  );
};
